/* FD brand ---------------------------------------------------------------
   Furniture Done fabrics and samples page: the family filter.

   One behaviour only — press a chip, show that family's tiles, update the
   count. Everything else on the page is native: the guide is <details>, and
   "Add sample" is Dawn's own <product-form>, so adding a swatch goes through
   the same cart and the same drawer a sofa does.

   With JS off, every tile is already in the document and visible; the chips
   simply do nothing. Nothing is hidden waiting to be revealed.

   The sticky offset the chip bar rides on is measured by fd-collection.js,
   which this page loads for exactly that reason.
   ------------------------------------------------------------------------ */
(function () {
  'use strict';

  function init(root) {
    var chips = root.querySelectorAll('[data-fd-filter]');
    var tiles = root.querySelectorAll('[data-fd-fam]');
    var count = root.querySelector('[data-fd-count]');
    if (!chips.length || !tiles.length) return;

    var noun = count ? count.getAttribute('data-fd-count') : '';

    function apply(family) {
      var shown = 0;

      tiles.forEach(function (tile) {
        var match = family === 'all' || tile.getAttribute('data-fd-fam') === family;
        tile.hidden = !match;
        if (match) shown += 1;
      });

      chips.forEach(function (chip) {
        chip.setAttribute('aria-pressed', chip.getAttribute('data-fd-filter') === family ? 'true' : 'false');
      });

      if (count) count.textContent = shown + ' ' + noun;
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        apply(chip.getAttribute('data-fd-filter'));
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-fd-swatch-grid]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* The theme editor re-renders a section in place, so the new markup needs
     wiring again. */
  document.addEventListener('shopify:section:load', function (event) {
    var grid = event.target.querySelector('[data-fd-swatch-grid]');
    if (grid) init(grid);
  });
})();
